import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useNavigate } from 'react-router-dom';


export default function UnAuthRoute({ children }) {

    let navigate = useNavigate();

    const token = useSelector(state => state.auth.token);
    const islogin = useSelector(state => state.auth.isLogin);
    
    return token.length === 0 && islogin === false ? children : <Navigate to="/" replace />;

}
